<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="修改核销" v-model="hideShow" width="500px" persistent>
			<v-card>
				<v-card-title>
					<span>修改核销记录</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="6">
							<v-select :items="statusItems" v-model="update.oldStatus" item-text="text"
								item-value="id" label="原到课状态" disabled dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-text-field label="原扣课时数" v-model="update.oldReduceQty" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-select :items="statusItems" v-model="update.newStatus" item-text="text"
								item-value="id" label="新到课状态"  dense outlined @change="newStatusChanged"></v-select>
						</v-col>
						<v-col cols="6">
							<v-text-field label="新扣课时数" v-model="update.newReduceQty" type="number" dense outlined></v-text-field>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitUpdate" :disabled="update.submitting" :loading="update.submitting" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"update-reocrd-detail",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			recordDetail:{
				type:Object,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.update.detailId =this.recordDetail.id;
					this.update.oldStatus = this.recordDetail.status;
					this.update.oldReduceQty = this.recordDetail.reduceQty;
					this.update.newStatus = "";
					this.update.newReduceQty = "";
				}
			}
		},
		data(){
			return {
				shopId:"",
				hideShow:this.show,
				update:{
					submitting:false,
					detailId:"",
					oldStatus:"",
					oldReduceQty:"",
					newStatus:"",
					newReduceQty:""
				},
				statusItems:[
					{id:"1",text:"到课"},
					{id:"2",text:"请假"},
					{id:"3",text:"旷课"},
				]
			}
		},
		mounted() {
			console.log("update-reocrd-detail mounted");
			this.shopId = utils.getCurrentShopId();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			newStatusChanged(){
				if(this.update.newStatus == "1"){
					this.update.newReduceQty = "1";
				}else{
					this.update.newReduceQty = "0";
				}
			},
			submitUpdate(){
				if(!this.update.newStatus){
					this.$noty.error("请选择新到课状态");
					return
				}
				if(!this.update.newReduceQty){
					this.$noty.error("请输入新的扣课时数");
					return
				}
				this.update.submitting = true;
				
				
				let postData = {
					...this.update
				}
				
				
				// api
				const that = this;
				let url = `/edu/approved/record/detail/update`;
					
				this.axios.post(url, postData).catch(() => {
					that.update.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.update.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.update.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.update.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
			},
		}
	}
	
</script>

<style>
</style>
